import script from "./PassTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./PassTable.vue?vue&type=script&lang=ts&setup=true"

export default script